import React, { useEffect, useState } from 'react';
import { api, fmtDay, AUDIENCE_WORDS } from './api.js';
import { Card, StatusPill, Pill } from './ui.jsx';

export default function LibraryTab({ onOpen, refreshKey }) {
  const [data, setData] = useState(null);
  const [showExpired, setShowExpired] = useState(false);
  useEffect(() => { let dead = false; api('/library').then((d) => { if (!dead) setData(d?.success ? d : { items: [], translations: [] }); }); return () => { dead = true; }; }, [refreshKey]);
  if (!data) return <p className="text-sm text-slate-400">Loading…</p>;
  const items = data.items.filter((i) => showExpired || !i.expired);
  return (
    <Card title="Approved materials" right={<label className="text-xs text-slate-500 flex items-center gap-2"><input type="checkbox" checked={showExpired} onChange={(e) => setShowExpired(e.target.checked)} /> show expired and retired</label>}>
      {!items.length ? <p className="text-sm text-slate-500">Nothing approved yet. Approved materials appear here with their ID and version; staff pull the current one from this list.</p> : (
        <div className="divide-y divide-slate-100 -mx-5">
          {items.map((m) => {
            const tr = data.translations.filter((t) => t.parent_id === m.id);
            return (
              <div key={m.id} className="px-5 py-3">
                <button type="button" onClick={() => onOpen(m.id)} className="text-left w-full">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="font-mono text-xs text-slate-500">{m.material_id || 'no ID'}</span>
                    <span className="text-sm font-semibold text-slate-900">{m.title}</span>
                    <Pill>v{m.version_no}</Pill>
                    <StatusPill status={m.status} />
                    {m.expired && <Pill tone="bg-slate-100 text-slate-500 ring-slate-200">Expired</Pill>}
                    {m.hpms_status && m.hpms_status !== 'not_submitted' && <Pill tone="bg-blue-50 text-blue-700 ring-blue-200">HPMS {m.hpms_status.replace(/_/g, ' ')}</Pill>}
                  </div>
                  <div className="text-xs text-slate-500 mt-1">{(m.audience || []).map((a) => AUDIENCE_WORDS[a] || a).join(', ')} · {m.lifecycle === 'contract_year' ? `CY${m.contract_year || ''}` : `${fmtDay(m.start_date) || 'start not set'}${m.end_date ? ` to ${fmtDay(m.end_date)}` : ''}`} · {m.file_name} · sha256 {String(m.sha256 || '').slice(0, 12)}</div>
                </button>
                {tr.length > 0 && (
                  <div className="mt-2 ml-4 flex flex-wrap gap-2">
                    {tr.map((t) => <button key={t.id} type="button" onClick={() => onOpen(t.id)} className="text-xs px-2 py-1 rounded-lg bg-slate-50 border border-slate-200 text-slate-600">{t.language.toUpperCase()} translation · v{t.version_no} · {t.status}</button>)}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </Card>
  );
}
